// src/js/components/SideNavigation.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default class SideNavigation {
    constructor() {
        this.nav = document.querySelector('[data-side-nav]');
        if (!this.nav) return;

        this.links = this.nav.querySelectorAll('.side-nav__link');
        this.indicator = this.nav.querySelector('.side-nav__indicator');
        this.sections = [];

        this.init();
    }

    init() {
        this.cacheSections();
        this.setupVisibility();
        this.setupTracking();
        this.setupClicks();
    }

    cacheSections() {
        this.links.forEach((link, index) => {
            const sectionId = link.dataset.section;
            const section = document.getElementById(sectionId);

            if (section) {
                this.sections.push({
                    id: sectionId,
                    element: section,
                    link: link,
                    index: index
                });
            }
        });
    }

    setupVisibility() {
        const firstSection = this.sections[0]?.element;
        if (!firstSection) return;

        ScrollTrigger.create({
            trigger: firstSection,
            start: 'top center',
            onEnter: () => this.nav.classList.add('is-visible'),
            onLeaveBack: () => this.nav.classList.remove('is-visible')
        });
    }

    setupTracking() {
        this.sections.forEach((section) => {
            ScrollTrigger.create({
                trigger: section.element,
                start: 'top center',
                end: 'bottom center',
                onEnter: () => this.setActive(section),
                onEnterBack: () => this.setActive(section)
            });
        });
    }

    setActive(section) {
        // Retire la classe active de tous les liens
        this.links.forEach(link => link.classList.remove('is-active'));

        // Ajoute la classe active au lien courant
        section.link.classList.add('is-active');

        // Déplace l'indicateur
        this.moveIndicator(section.index);
    }

    moveIndicator(index) {
        const linkHeight = 40; // Hauteur approximative d'un link (padding inclus)
        const targetY = index * linkHeight;

        gsap.to(this.indicator, {
            y: targetY,
            duration: 0.6,
            ease: 'power3.out'
        });
    }

    setupClicks() {
        this.links.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const sectionId = link.dataset.section;
                const section = document.getElementById(sectionId);

                if (section) {
                    gsap.to(window, {
                        duration: 1,
                        scrollTo: {
                            y: section,
                            offsetY: 80
                        },
                        ease: 'power2.inOut'
                    });
                }
            });
        });
    }

    destroy() {
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }
}